import { FC, useCallback, useMemo } from 'react';
import uuid from 'react-uuid';
import Button from 'src/components/design-system/Button';
import usePeriodView from 'src/hooks/usePeriodView';
import useViewCheckbook from 'src/hooks/useViewCheckbook';
import { GLCodePeriodDepartment } from 'src/services/useGlCodeDepartmentApi';
import { Card } from 'src/services/useGlCodesBudgetApi';

interface Props {}

const AddGlCode: FC<Props> = () => {
  const {
    setEditingGlCodePeriodBudget,
    setOriginalGlCodePeriodBudget,
    setIsEditMode,
    setPeriodCheckbookDataState,
    isEditMode,
  } = useViewCheckbook();

  const { periodViewData, dropdownPeriodFilter } = usePeriodView();

  const handleAddGLCode = useCallback(() => {
    const newData = {
      id: Math.random(),
      selected: false,
      departments: [] as GLCodePeriodDepartment[],
      code: '',
      description: '',
      budgetAmount: 0,
      _initialBudget: null,
      initialBudget: null,
      holdAmount: 0,
      spentAmount: 0,
      committedAmount: 0,
      remainingBudgetAmount: 0,
      remainingBudgetAmountPercentage: 0,
      remainingInitialBudgetAmount: null,
      isFixed: true,
      isActive: true,
      isNewGlCode: true,
      rowId: uuid(),
      card: 'subtract' as Card,
      newAmount: 0,
      periodBudgets: 0,
      sortKey: '',
    };

    document
      .querySelector('#viewPeriodCheckbookTable .k-grid-content.k-virtual-content')
      ?.scrollTo({ top: 0 });

    if (isEditMode) {
      setEditingGlCodePeriodBudget((prev) => [newData, ...prev]);
    } else {
      const data = [newData, ...periodViewData];
      setEditingGlCodePeriodBudget(data);
      setOriginalGlCodePeriodBudget(data);
    }
    setPeriodCheckbookDataState((prev) => ({ ...prev, skip: 0 }));
    setIsEditMode(true);
  }, [
    isEditMode,
    setPeriodCheckbookDataState,
    setIsEditMode,
    setEditingGlCodePeriodBudget,
    periodViewData,
    setOriginalGlCodePeriodBudget,
  ]);

  const isAddHidden = useMemo(() => dropdownPeriodFilter.value === 4, [dropdownPeriodFilter.value]);

  return isAddHidden ? (
    <></>
  ) : (
    <Button onClick={handleAddGLCode} color="primary">
      Add New GL Code
    </Button>
  );
};

export default AddGlCode;
